import { SELECTED_PROJECT } from "../../configuration";

export const getLinks = () => {
  const linksData = {
    alicia: [
      { name: "products", path: "/products" },
      { name: "assetManagement", path: "/asset-management" },
    ],
    alliance: [
      { name: "datasets", path: "/datasets" },
      { name: "myDatasets", path: "/my-datasets" },
      { name: "systemicInnovations", path: "/systemic-innovations" },
      { name: "mySystemicInnovations", path: "/my-systemic-innovations" },
    ],
    "r3-mydas": [
      { name: "products", path: "/products" },
      { name: "assetManagement", path: "/asset-management" },
    ],
  };

  return linksData[SELECTED_PROJECT] ?? [];
};
